import { useCallback } from "react";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "services/api.service";
import { Asset } from "types/asset";
import { Person } from "types/person";

export default function useAsset({ uuid }: { uuid: string | undefined }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: asset, isLoading, isError, refetch } = useQuery(
    ["portal-asset", uuid],
    () => api.get<Asset>(`/assets/${uuid}`).then((r) => r.data),
    { enabled: Boolean(uuid) }
  );

  const checkout = useCallback(
    (person: Person) =>
      api.post(`/assets/${uuid}/checkout`, { person }).then(() => {
        navigate(`/assets/${uuid}/edit`, {
          state: {
            from: `${location.pathname}${location.search}`,
          },
        });
      }),
    [navigate, location.pathname, location.search, uuid]
  );

  return {
    asset,
    isLoading,
    isError,
    refetch,
    checkout,
  };
}
